var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.row.localOrder?.today_local_order)?_c('div',[_vm._v(" "+_vm._s(_vm.row.localOrder?.today_local_order?.validOrderCount)+" / "+_vm._s(_vm.row.localOrder?.today_local_order?.orderCount)+" ")]):_c('div',[_vm._v(" -- ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }